import { isDefined } from '@sama/js-core';
// eslint-disable-next-line import-whitelist -- There is not a better place to put these helpers
import { AbstractSensorContentState2D } from '../../2d/shared/state/abstract-sensor-content-state-2d';
// eslint-disable-next-line import-whitelist -- There is not a better place to put these helpers
import { AbstractSensorContentStore2D } from '../../2d/shared/state/abstract-sensor-content-store-2d';
import { PointCloudContentState } from '../../3d/state/point-cloud-content-state';
import { PointCloudContentStore } from '../../3d/state/point-cloud-content-store';
import { AbstractSensorContentStore } from '../state/abstract-sensor-content-store';

export function getViewModeStore(store: AbstractSensorContentStore) {
  if (isPointCloudContentStore(store)) {
    return store('render')('viewMode');
  } else if (isSensorContentStore2D(store)) {
    return store('viewMode');
  } else {
    throw new Error('Unsupported store type');
  }
}

function isPointCloudContentStore(
  store: AbstractSensorContentStore,
): store is PointCloudContentStore {
  return isDefined((store.state() as PointCloudContentState).render);
}

function isSensorContentStore2D(
  store: AbstractSensorContentStore,
): store is AbstractSensorContentStore2D {
  return isDefined((store.state() as AbstractSensorContentState2D).viewBox);
}
